export default "__VITE_ASSET__jwoh5Fey__"